<template>

  <div>
    <el-row :gutter="20">
      <el-col :span="8">
        <el-card class="box-card" v-loading="loadChart1">
          <div slot="header" class="clearfix">
            <span>最近新增新闻</span>
            <el-button style="float: right; padding: 3px 0" type="text" @click="handleLoadChart1">
              <i class="el-icon-refresh"/>
              刷新
            </el-button>
          </div>
          <v-chart class="chart" :option="option" ref="chart1"/>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card class="box-card" v-loading="loadChart2">
          <div slot="header" class="clearfix">
            <span>数据来源Top10</span>
            <el-button style="float: right; padding: 3px 0" type="text" @click="handleLoadChart2">
              <i class="el-icon-refresh"/>
              刷新
            </el-button>
          </div>
          <v-chart class="chart" :option="option2" ref="chart2"/>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card class="box-card" v-loading="loadChart3" style="height: 410px;overflow: auto">
          <div slot="header" class="clearfix">
            <span>新闻动态</span>
            <el-button style="float: right; padding: 3px 0" type="text" @click="handleLoadChart3">
              <i class="el-icon-refresh"/>
              刷新
            </el-button>
          </div>
            <el-row :gutter="10" style="padding:9px;text-align:left;" v-for="o in news" :key="o.link" class="text item">
              <el-col :span="24">
                <el-link type="primary" :href="o.link" target="_blank">
                  {{ o.title }}
                </el-link>
              </el-col>
            </el-row>
        </el-card>
      </el-col>
    </el-row>
    <el-row >
      <el-col :span="24" >
        <el-card class="box-card" style="height: 600px;margin-top: 20px" v-loading="loadChart4">
          <div slot="header" class="clearfix">
            <span>系统面板</span>
            <el-button style="float: right; padding: 3px 0" type="text" @click="handleLoadChart4">
              <i class="el-icon-refresh"/>
              刷新
            </el-button>
          </div>
          <v-chart class="chart" :option="option3" style="height: 500px" ref="chart4"/>
        </el-card>
      </el-col>
    </el-row>


  </div>


</template>

<script>

import VChart from "vue-echarts";
import "echarts";
import axios from "axios";
import {mapState} from "vuex";

export default {
  name: "DataScreen",
  computed:{
    ...mapState(['baseUrl'])
  },
  components: {
    VChart
  },
  data() {
    return {
      loadChart1: false,
      loadChart2: false,
      loadChart3: false,
      loadChart4: false,
      news:[],
      option: {
        xAxis: {
          type: 'category',
          data: ['前天', '昨天', '今天']
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            data: [20, 30, 50],
            type: 'line',
            smooth: true
          }
        ]
      },
      option2: {
        tooltip: {
          trigger: 'item',
        },
        legend: {
          orient: 'vertical',
          left: 'left'
        },
        series: [
          {
            name: '新闻总量',
            type: 'pie',
            radius: '50%',
            data: [
              {value: 1048, name: '第一财经'},
              {value: 735, name: '全景网'},
              {value: 580, name: '证券之星'},
              {value: 484, name: '和讯网'},
              {value: 300, name: '财经网'}
            ],
            label: {      // 控制标签文字
              show: false
            },
            labelLine: {
              show: false         // 关闭连接线
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      },
      option3:{
        title: {
          text: '运行状态'
        },
        tooltip: {},
        animation: true, // 开启动画
        animationDuration: 1000, // 动画时长
        animationDurationUpdate: 1500,
        animationEasingUpdate: 'quinticInOut',
        series: [
          {
            type: 'graph',
            layout: 'none',
            symbolSize: 80,//圆圈大小
            roam: true,
            label: {
              show: true,
              fontSize: 20//字体大小
            },
            edgeSymbol: ['circle', 'arrow'],
            edgeSymbolSize: [4, 10],
            edgeLabel: {
              fontSize: 20
            },
            data: [
              {
                name: '前端',
                x: -1000,
                y: 0,
                itemStyle: {
                  color: '#41b883'
                }
              },
              {
                name: '后端',
                x: 0,
                y: 0,
                itemStyle: {
                  color: '#7ed3f4'
                }
              },
              {
                name: 'CNN',
                x: 1000,
                y: 0,
                itemStyle: {
                  color: '#e2865b'
                }
              },
              {
                name: 'DS',
                x: -707,
                y: +707,
                itemStyle: {
                  color: '#444447'
                }
              },
              {
                name: '爬虫1',
                x: 0,
                y: -1000,
                itemStyle: {
                  color: '#015a6e'
                }
              },
              {
                name: '爬虫2',
                x: -700,
                y: -700,
                itemStyle: {
                  color: '#015a6e'
                }
              },
              {
                name: '爬虫3',
                x: 700,
                y: -700,
                itemStyle: {
                  color: '#015a6e'
                }
              },
              {
                name: '数据库',
                x: 707,
                y: 707,
                itemStyle: {
                  color: '#ffdc60'
                }
              }
            ],
            // links: [],
            links: [
              {
                source: '前端',
                target: '后端',
                symbolSize: [1, 20],
                lineStyle: {
                  width: 5,
                  curveness: 0.2,
                  color: '#8ae8ff'
                }
              },
              {
                source: '后端',
                target: '前端',
                symbolSize: [1, 20],
                lineStyle: {
                  width: 5,
                  curveness: 0.2,
                  color: '#41b883'
                }
              },
              {
                source: '后端',
                target: 'DS',
                symbolSize: [10, 20],
                lineStyle: {
                  width: 5,
                  curveness: 0.2,
                  color: '#444447'
                }
              },
              {
                source: 'DS',
                target: '后端',
                symbolSize: [10, 20],
                lineStyle: {
                  width: 5,
                  curveness: 0.2,
                  color: '#8ae8ff'
                },
              },
              {
                source: '后端',
                target: 'CNN',
                symbolSize: [10, 20],
                lineStyle: {
                  width: 5,
                  curveness: 0.2,
                  color: '#e2865b'
                }
              },
              {
                source: 'CNN',
                target: '后端',
                symbolSize: [10, 20],
                lineStyle: {
                  width: 5,
                  curveness: 0.2,
                  color: '#8ae8ff'
                },
              },
              {
                source: '后端',
                target: '数据库',
                symbolSize: [10, 20],
                lineStyle: {
                  width: 5,
                  curveness: 0.2,
                  color: '#ffdc60'
                }
              },
              {
                source: '数据库',
                target: '后端',
                symbolSize: [10, 20],
                lineStyle: {
                  width: 5,
                  curveness: 0.2,
                  color: '#8ae8ff'
                },
              },
              {
                source: '爬虫1',
                target: '后端',
                symbolSize: [10, 20],
                lineStyle: {
                  width: 5,
                  color: '#8ae8ff'
                },
              },
              {
                source: '爬虫2',
                target: '后端',
                symbolSize: [10, 20],
                lineStyle: {
                  width: 5,
                  color: '#8ae8ff'
                },
              },
              {
                source: '爬虫3',
                target: '后端',
                symbolSize: [10, 20],
                lineStyle: {
                  width: 5,
                  color: '#8ae8ff'
                },
              }
            ],
            lineStyle: {
              opacity: 0.9,
              width: 2,
              curveness: 0
            }
          }
        ]
      }
    }
  },
  methods: {
    getRecentDates() {
  const today = new Date();
  // today.setDate(today.getDate() - 10)
  const yesterday = new Date(today);
  const dayBeforeYesterday = new Date(today);

  yesterday.setDate(today.getDate() - 1);
  dayBeforeYesterday.setDate(today.getDate() - 2);

  const formatDate = (date) => {
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0'); // 月份是从0开始的
    const dd = String(date.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  };

  return {
    today: formatDate(today),
    yesterday: formatDate(yesterday),
    dayBeforeYesterday: formatDate(dayBeforeYesterday)
  };
},
    requestTotal(day){
      return axios.get(`${this.baseUrl}/news/query/light`,{params: {
          "startDate":day,
          "endDate":day,
          "pageSize":20
        }})
    },
    handleLoadChart1() {
      this.loadChart1 = true
      const dates = this.getRecentDates();
      setTimeout(() => {
        // 使用Promise.all来等待所有请求完成
        Promise.all([this.requestTotal(dates.today), this.requestTotal(dates.yesterday),this.requestTotal(dates.dayBeforeYesterday)]).then(responses => {
          // 所有请求都成功完成
          const [responseOne, responseTwo, responseThree] = responses;
          this.$set(this.option.series[0].data,2,responseOne.data.total)
          this.option.series[0].data[1]=responseTwo.data.total
          this.option.series[0].data[0]=responseThree.data.total
        }).catch(error => {
          // 如果任何一个请求失败，都会进入这个catch块
          console.error('获取数据失败:', error)
          this.$message.error('获取数据失败，请稍后重试')
        }).finally(()=>{
          this.loadChart1 = false
        });
      })
      this.$refs.chart1 && this.$refs.chart1.clear()
      this.$refs.chart1 && this.$refs.chart1.setOption(this.option)
    },
    handleLoadChart2() {
      this.loadChart2 = true
      setTimeout(() => {

        axios.get(`${this.baseUrl}/news/source`,{params:{pageSize:10}}).then(responses => {
          this.option2.series[0].data=[]
          console.log(responses.data.data)
          responses.data.data.forEach(item =>
          {
            console.log(item)
            this.option2.series[0].data.unshift({
              name: item.source,
              value: item.count,
            })
          })
          console.log(this.option2)
        }).finally(()=>{
          this.loadChart2 = false
        })
        this.$refs.chart2 && this.$refs.chart2.clear()
        this.$refs.chart2 && this.$refs.chart2.setOption(this.option2)
      })
    },
    handleLoadChart3() {
      this.loadChart3 = true
      setTimeout(()=>{
        axios.get(`${this.baseUrl}/news/query/light`,{params: {
            "orderDate":false,
            "pageSize":6
          }}).then(res => {
          this.news = res.data.data
        }).finally(()=>{
          this.loadChart3 = false
        })
      })
    },
    handleLoadChart4() {
      this.loadChart4 = true
      setTimeout(() => {
        this.loadChart4 = false
        this.$refs.chart4 && this.$refs.chart4.clear()
        this.$refs.chart4 && this.$refs.chart4.setOption(this.option3)
      },300)
    },
    handleResize(){
      this.$refs.chart1 && this.$refs.chart1.resize()
      this.$refs.chart2 && this.$refs.chart2.resize()
      this.$refs.chart4 && this.$refs.chart4.resize()
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize)
    this.handleLoadChart1()
    this.handleLoadChart2()
    this.handleLoadChart3()
    this.handleLoadChart4()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  }

};
</script>

<style scoped>
h4 {
  display: inline-block;
  margin: 3px;
  padding: 5px;
  width: 100%;
  text-align: center;
}

.chart {
  height: 300px;
  width: 100%;
  align-content: center;
  display: block;

}

.box {
  border: 1px solid #1e1f22;
  height: 300px;
}

.bg-purple {
  background: #d3dce6;
}

.grid-content {
  border-radius: 4px;
  min-height: 360px;
}
</style>